export default "__VITE_ASSET__Car8GxFK__"